<!-- src/components/Footer.svelte -->
<script>
  import { currentLang, t } from "../lib/i18n";
  import { onMount } from "svelte";

  export let navigate;

  let lang;
  let showBackToTop = false;

  // Subscribe to language changes
  currentLang.subscribe((value) => {
    lang = value;
  });

  function scrollToTop() {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }

  // Function to open Google Maps directions to A&T Group
  function openGoogleMapsDirections() {
    window.open(
      "https://www.google.com/maps/place/A%26T+Rept%C3%A9ri+Parkol%C3%B3+%C3%A9s+K%C3%A9zi+Aut%C3%B3mos%C3%B3/@47.409985,19.0926473,21108m/data=!3m1!1e3!4m10!1m2!2m1!1sat+parking!3m6!1s0x4741c1683c4acc0d:0xd5187321a7799279!8m2!3d47.4099852!4d19.232723!15sCgphdCBwYXJraW5nkgELcGFya2luZ19sb3TgAQA!16s%2Fg%2F11zh3c3lc4?entry=ttu&g_ep=EgoyMDI2MDgxMi4wIKXMDSoASAFQAw%3D%3D",
      "_blank",
    );
  }

  onMount(() => {
    const handleScroll = () => {
      showBackToTop = window.scrollY > 300;
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  });
</script>

<footer>
  <div class="footer-top">
    <div class="container">
      <div class="footer-grid">
        <div class="footer-info">
          <div class="footer-logo">
            <img src="images/newlogblue.png" alt="A&T Group" />
          </div>
          <div class="contact-info">
            <h3>{t("footer.visit", $currentLang)}</h3>
            <p class="address">{t("footer.address", $currentLang)}</p>
            <p>
              <strong>{t("footer.phone", $currentLang)}:</strong>
              <a href="tel:+36705859959" class="contact-link">+36 70 585 9959</a>,
              <a href="tel:+36707343444" class="contact-link">+36 70 734 3444</a>
            </p>
            <p>
              <strong>{t("footer.email", $currentLang)}:</strong>
              <a href="mailto:info@atgroup.hu" class="contact-link"
                >{t("footer.emailAddress", $currentLang)}</a
              >
            </p>
          </div>
          <div class="social-links">
            <a
              href="https://www.facebook.com/p/AT-Rept%C3%A9ri-Parkol%C3%B3-%C3%A9s-K%C3%A9zi-Aut%C3%B3mos%C3%B3-61594838726330/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Facebook"
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12 2.04001C6.5 2.04001 2 6.53001 2 12.06C2 17.06 5.66 21.21 10.44 21.96V14.96H7.9V12.06H10.44V9.85001C10.44 7.34001 11.93 5.96001 14.22 5.96001C15.31 5.96001 16.45 6.15001 16.45 6.15001V8.62001H15.19C13.95 8.62001 13.56 9.39001 13.56 10.18V12.06H16.34L15.89 14.96H13.56V21.96C15.9164 21.5879 18.0622 20.3855 19.6099 18.5701C21.1576 16.7546 22.0054 14.4457 22 12.06C22 6.53001 17.5 2.04001 12 2.04001Z"
                  fill="currentColor"
                />
              </svg>
            </a>
            <a
              href="https://www.instagram.com/zima_auto/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12 2C14.717 2 15.056 2.01 16.122 2.06C17.187 2.11 17.912 2.277 18.55 2.525C19.21 2.779 19.766 3.123 20.322 3.678C20.8305 4.1779 21.224 4.78259 21.475 5.45C21.722 6.087 21.89 6.813 21.94 7.878C21.987 8.944 22 9.283 22 12C22 14.717 21.99 15.056 21.94 16.122C21.89 17.187 21.722 17.912 21.475 18.55C21.2247 19.2178 20.8311 19.8226 20.322 20.322C19.822 20.8303 19.2173 21.2238 18.55 21.475C17.913 21.722 17.187 21.89 16.122 21.94C15.056 21.987 14.717 22 12 22C9.283 22 8.944 21.99 7.878 21.94C6.813 21.89 6.088 21.722 5.45 21.475C4.78233 21.2245 4.17753 20.8309 3.678 20.322C3.16941 19.8222 2.77593 19.2175 2.525 18.55C2.277 17.913 2.11 17.187 2.06 16.122C2.013 15.056 2 14.717 2 12C2 9.283 2.01 8.944 2.06 7.878C2.11 6.812 2.277 6.088 2.525 5.45C2.77524 4.78218 3.1688 4.17732 3.678 3.678C4.17767 3.16923 4.78243 2.77573 5.45 2.525C6.088 2.277 6.812 2.11 7.878 2.06C8.944 2.013 9.283 2 12 2ZM12 7C10.6739 7 9.40215 7.52678 8.46447 8.46447C7.52678 9.40215 7 10.6739 7 12C7 13.3261 7.52678 14.5979 8.46447 15.5355C9.40215 16.4732 10.6739 17 12 17C13.3261 17 14.5979 16.4732 15.5355 15.5355C16.4732 14.5979 17 13.3261 17 12C17 10.6739 16.4732 9.40215 15.5355 8.46447C14.5979 7.52678 13.3261 7 12 7ZM18.5 6.75C18.5 6.41848 18.3683 6.10054 18.1339 5.86612C17.8995 5.6317 17.5815 5.5 17.25 5.5C16.9185 5.5 16.6005 5.6317 16.3661 5.86612C16.1317 6.10054 16 6.41848 16 6.75C16 7.08152 16.1317 7.39946 16.3661 7.63388C16.6005 7.8683 16.9185 8 17.25 8C17.5815 8 17.8995 7.8683 18.1339 7.63388C18.3683 7.39946 18.5 7.08152 18.5 6.75ZM12 9C12.7956 9 13.5587 9.31607 14.1213 9.87868C14.6839 10.4413 15 11.2044 15 12C15 12.7956 14.6839 13.5587 14.1213 14.1213C13.5587 14.6839 12.7956 15 12 15C11.2044 15 10.4413 14.6839 9.87868 14.1213C9.31607 13.5587 9 12.7956 9 12C9 11.2044 9.31607 10.4413 9.87868 9.87868C10.4413 9.31607 11.2044 9 12 9Z"
                  fill="currentColor"
                />
              </svg>
            </a>
          </div>
        </div>

        <div class="footer-links">
          <h3>{t("footer.links", $currentLang)}</h3>
          <ul>
            <li>
              <a href="#home" on:click|preventDefault={() => navigate("home")}>
                {t("nav.home", $currentLang)}
              </a>
            </li>
            <li>
              <a
                href="#booking"
                on:click|preventDefault={() => navigate("booking")}
              >
                {t("nav.booking", $currentLang)}
              </a>
            </li>
            <li>
              <a
                href="#about"
                on:click|preventDefault={() => navigate("about")}
              >
                {t("nav.about", $currentLang)}
              </a>
            </li>
            <li>
              <a
                href="#services"
                on:click|preventDefault={() => navigate("services")}
              >
                {t("nav.services", $currentLang)}
              </a>
            </li>
            <li>
              <a
                href="#faq"
                on:click|preventDefault={() => {
                  window.scrollTo({ top: 0, behavior: "instant" });
                  navigate("faq");
                }}
              >
                {t("nav.faq", $currentLang)}
              </a>
            </li>
            <li>
              <a
                href="#contact"
                on:click|preventDefault={() => navigate("contact")}
              >
                {t("nav.contact", $currentLang)}
              </a>
            </li>
          </ul>
        </div>

        <div class="footer-map">
          <div class="map-container">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2700.0990847936746!2d19.230148076877074!3d47.40998517117243!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4741c1683c4acc0d%3A0xd5187321a7799279!2sA%26T%20Rept%C3%A9ri%20Parkol%C3%B3%20%C3%A9s%20K%C3%A9zi%20Aut%C3%B3mos%C3%B3!5e0!3m2!1shu!2shu!4v1745609320883!5m2!1shu!2shu"
              width="100%"
              height="100%"
              style="border:0;"
              allowfullscreen=""
              loading="lazy"
              referrerpolicy="no-referrer-when-downgrade"
              title="A&T Group location"
            >
            </iframe>
            <button class="directions-link" on:click={openGoogleMapsDirections}>
              {$currentLang === "hu" ? "Útvonaltervezés" : "Get Directions"}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path d="M9 18l6-6-6-6" />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="footer-bottom">
    <div class="container">
      <p>{t("footer.copyright", $currentLang)}</p>
      <div class="legal-links">
        <a
          href="#privacy"
          on:click|preventDefault={() => navigate("privacy")}
          class="legal-link"
        >
          {$currentLang === "hu" ? "Adatvédelmi irányelvek" : "Privacy Policy"}
        </a>
        <span class="separator">•</span>
        <a
          href="#imprint"
          on:click|preventDefault={() => navigate("imprint")}
          class="legal-link"
        >
          {$currentLang === "hu" ? "Impresszum" : "Imprint"}
        </a>
        <span class="separator">•</span>
        <a
          href="#terms"
          on:click|preventDefault={() => navigate("terms")}
          class="legal-link"
        >
          {$currentLang === "hu" ? "ÁSZF" : "Terms & Conditions"}
        </a>
      </div>
    </div>
  </div>

  <a
    href="https://wa.me/36705859959"
    class="whatsapp-btn"
    target="_blank"
    rel="noopener noreferrer"
    aria-label="WhatsApp"
  >
    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="currentColor">
      <path d="M12.031 21c-1.636 0-3.222-.416-4.648-1.211L3 20.916l1.173-4.223A8.956 8.956 0 013 12c0-4.962 4.038-9 9-9s9 4.038 9 9-4.038 9-8.969 9zM12 4.606C7.925 4.606 4.606 7.925 4.606 12c0 1.62.52 3.167 1.493 4.444l-.678 2.44 2.508-.658a7.359 7.359 0 004.071 1.211c4.075 0 7.394-3.319 7.394-7.394 0-4.075-3.319-7.394-7.394-7.394zm3.968 10.37c-.218-.109-1.287-.636-1.485-.709-.199-.073-.343-.109-.488.109-.144.218-.564.709-.691.854-.127.145-.254.164-.472.055-.218-.109-.918-.338-1.748-1.077-.645-.575-1.08-1.285-1.207-1.503-.127-.218-.014-.336.095-.445.099-.098.218-.254.327-.381.109-.127.145-.218.218-.363.073-.145.036-.272-.018-.381-.055-.109-.488-1.18-.669-1.616-.176-.425-.355-.367-.488-.374-.127-.007-.272-.007-.418-.007s-.381.055-.581.272c-.199.218-.763.745-.763 1.816s.781 2.107.89 2.253c.109.145 1.536 2.344 3.725 3.29.52.225.926.359 1.242.459.523.166 1.001.143 1.381.087.427-.063 1.287-.527 1.468-1.036.182-.509.182-.945.127-1.036-.054-.091-.199-.145-.417-.254z"/>
    </svg>
  </a>

  <button
    class="back-to-top"
    class:visible={showBackToTop}
    on:click={scrollToTop}
    aria-label={$currentLang === "hu" ? "Vissza a tetejére" : "Back to top"}
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <path d="M18 15l-6-6-6 6" />
    </svg>
  </button>
</footer>

<style>
  footer {
    background-color: rgb(253, 251, 238);
    color: rgb(27, 42, 75);
  }

  .footer-top {
    padding: 60px 0;
  }

  .footer-grid {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    gap: 40px;
  }

  .footer-logo {
    margin-bottom: 25px;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
  }

  .footer-logo img {
    height: 65px;
    width: auto;
    max-width: 160px;
    object-fit: contain;
    display: block;
  }

  .contact-info h3 {
    margin-bottom: 20px;
    font-size: 1.1rem;
    position: relative;
    display: inline-block;
    color: rgb(27, 42, 75);
  }

  .contact-info h3::after {
    content: "";
    position: absolute;
    bottom: -8px;
    left: 0;
    width: 40px;
    height: 2px;
    background-color: rgb(27, 42, 75);
  }

  .contact-info p {
    margin-bottom: 10px;
    font-size: 0.95rem;
    color: #333;
    line-height: 1.6;
  }

  .social-links {
    display: flex;
    gap: 15px;
    margin-top: 25px;
  }

  .social-links a {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    background-color: rgba(27, 42, 75, 0.1);
    border-radius: 50%;
    color: rgb(27, 42, 75);
    transition: all 0.3s ease;
  }

  .social-links a:hover {
    background-color: rgb(27, 42, 75);
    color: white;
    transform: translateY(-3px);
  }

  .footer-links h3 {
    margin-bottom: 20px;
    font-size: 1.1rem;
    position: relative;
    display: inline-block;
    color: rgb(27, 42, 75);
  }

  .footer-links h3::after {
    content: "";
    position: absolute;
    bottom: -8px;
    left: 0;
    width: 40px;
    height: 2px;
    background-color: rgb(27, 42, 75);
  }

  .footer-links ul {
    list-style: none;
    padding: 0;
    margin: 0;
  }

  .footer-links li {
    margin-bottom: 12px;
  }

  .footer-links a {
    color: #333;
    transition: all 0.3s ease;
    display: inline-block;
    position: relative;
    padding-left: 15px;
  }

  .footer-links a::before {
    content: "";
    position: absolute;
    left: 0;
    top: 50% !important;
    transform: translateY(-50%);
    width: 6px;
    height: 6px;
    background-color: rgb(27, 42, 75);
    border-radius: 50%;
  }

  .footer-links a:hover {
    color: rgb(27, 42, 75);
    padding-left: 20px;
  }

  .footer-map {
    position: relative;
    height: 250px;
    min-height: 250px;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
  }

  .footer-bottom {
    background-color: rgba(27, 42, 75, 0.05);
    padding: 20px 0;
    text-align: center;
  }

  .footer-bottom .container {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 20px;
  }

  .footer-bottom p {
    margin: 0;
    font-size: 0.9rem;
    color: #555;
  }

  .legal-links {
    display: flex;
    align-items: center;
    gap: 15px;
    flex-wrap: wrap;
    justify-content: center;
  }

  .legal-link {
    color: #555;
    text-decoration: none;
    font-size: 0.9rem;
    transition: color 0.3s ease;
  }

  .legal-link:hover {
    color: rgb(27, 42, 75);
  }

  .separator {
    color: #555;
    font-size: 0.9rem;
  }

  @media screen and (max-width: 992px) {
    .footer-grid {
      grid-template-columns: 1fr 1fr;
    }

    .footer-map {
      grid-column: span 2;
    }
  }

  @media screen and (max-width: 768px) {
    .footer-grid {
      grid-template-columns: 1fr;
      gap: 30px;
    }

    .footer-logo {
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;
      margin-bottom: 18px;
      text-align: left;
    }

    .footer-logo img {
      height: 50px;
      width: auto;
      max-width: 130px;
      margin-left: 0;
      margin-right: auto;
      display: block;
      object-fit: contain;
    }

    .footer-map {
      grid-column: span 1;
      height: 220px;
      min-height: 220px;
    }

    .footer-top {
      padding: 40px 20px;
    }

    .footer-bottom .container {
      flex-direction: column;
      gap: 10px;
    }
  }

  .back-to-top {
    position: fixed;
    bottom: 30px;
    right: 30px;
    width: 50px;
    height: 50px;
    border-radius: 50%;
    background-color: rgb(27, 42, 75);
    color: white;
    border: none;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0;
    visibility: hidden;
    transform: translateY(20px);
    transition: all 0.3s ease;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    z-index: 1000;
  }

  .whatsapp-btn {
    position: fixed;
    bottom: 90px;
    right: 30px;
    width: 50px;
    height: 50px;
    border-radius: 50%;
    background-color: #25d366;
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s ease;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    z-index: 1000;
  }

  .whatsapp-btn:hover {
    background-color: #128C7E;
    transform: translateY(-3px);
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);
  }

  .back-to-top.visible {
    opacity: 1;
    visibility: visible;
    transform: translateY(0);
  }

  .back-to-top:hover {
    background-color: rgb(45, 68, 115);
    transform: translateY(-3px);
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);
  }

  .back-to-top:focus {
    outline: none;
    box-shadow: 0 0 0 3px rgba(27, 42, 75, 0.3);
  }

  @media screen and (max-width: 768px) {
    .back-to-top {
      bottom: 20px;
      right: 20px;
      width: 40px;
      height: 40px;
    }
    .whatsapp-btn {
      bottom: 70px;
      right: 20px;
      width: 40px;
      height: 40px;
    }
    .whatsapp-btn svg {
      width: 24px;
      height: 24px;
    }
  }

  .map-container {
    position: relative;
    width: 100%;
    height: 100%;
  }

  .map-container iframe {
    width: 100%;
    height: 100%;
    border: none;
    display: block;
  }

  .directions-link {
    position: absolute;
    bottom: 10px;
    right: 10px;
    background-color: #111111;
    color: white;
    padding: 8px 16px;
    border-radius: 5px;
    text-decoration: none;
    display: flex;
    align-items: center;
    gap: 8px;
    font-weight: 500;
    font-size: 0.9rem;
    transition: background-color 0.3s ease;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
    border: none;
    cursor: pointer;
  }

  .directions-link:hover {
    background-color: #222222;
  }

  .contact-link {
    color: rgb(27, 42, 75);
    text-decoration: none;
    transition: color 0.3s ease;
  }

  .contact-link:hover {
    color: #555;
  }
</style>
